import React from "react";
import { useHistory } from "react-router";
import img1 from "../assets/images/img1.png";
import img2 from "../assets/images/img2.png";
import img3 from "../assets/images/img3.png";

const Projects = () => {
  const history = useHistory();
  return (
    <div className=" bg-gray-900 pb-5">
      <h1 className="text-center pt-3 text-xl text-white font-medium">
        ReactJs App's
      </h1>
      <div className="px-3 py-3 space-y-3 grid sm:grid-cols-2 lg:grid-cols-3 sm:items-center sm:gap-5 cursor-pointer sm:p-10">
        <div className="transform sm:hover:scale-110 transition delay-300 duration-300 ease-in-out">
          <img src={img1} alt="" className="object-contain shadow-lg" />
        </div>
        <div className="transform sm:hover:scale-110 transition delay-300 duration-300 ease-in-out shadow-lg">
          <img src={img2} alt="" className="object-contain" />
        </div>
        <div className="transform sm:hover:scale-110 transition delay-300 duration-300 ease-in-out">
          <img src={img3} alt="" className="object-contain" />
        </div>
      </div>
      <div className="flex justify-center mb-3 mt-2">
        <button
          onClick={() => history.push("/projects")}
          className="py-2 px-6 rounded-sm  text-sm  border border-gray-400 hover:bg-transparent bg-gray-200 hover:text-white font-medium shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-700"
        >
          View More Projects
        </button>
      </div>
    </div>
  );
};

export default Projects;
